import { TailscaleIconUrl } from "@p0security/shared/integrations/constants";
import { TailscaleComponents } from "@p0security/shared/integrations/resources/tailscale/components";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { tailscaleInstaller } from "./install/install";

export const Tailscale = (
  props: Pick<
    InstallProps<typeof TailscaleComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "organization", []);

  return (
    <Install<typeof TailscaleComponents>
      components={TailscaleComponents}
      installer={tailscaleInstaller}
      integration="tailscale"
      itemKind={itemKind}
      logo={TailscaleIconUrl}
      title="Tailscale"
      {...props}
    />
  );
};
